 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0bf8c9de":"2e7258b6","chunk-13510428":"870c6458","chunk-142563fa":"47e46023","chunk-36e63296":"2672f545","chunk-2e8a43f2":"f75dd184","chunk-c4bcedc6":"d335c9d7","chunk-34743a90":"050a43d7","chunk-3588aad4":"04f62406","chunk-1a3c5ce6":"33540a51","chunk-2d069e6b":"955f498d","chunk-3a6364ea":"647dfdfb","chunk-3c150860":"09a81f18","chunk-3e299a38":"f82d1acc","chunk-5f7e28b4":"5d92dac3","chunk-6e4f4f8e":"d50c99be","chunk-74f756a4":"6122ff76","chunk-b9ec4490":"e63c59f7","chunk-69de510c":"6b3ac9a1","chunk-a40ae960":"b3b76573","chunk-1156ef6a":"68307be2","chunk-b47bfb9a":"cceb4487","chunk-ce8b6022":"bc9b185f","chunk-47820dd6":"979cd09c","chunk-54239a8e":"ff6576bc","chunk-5a8d37be":"20f66eb3","chunk-5c790d61":"18a14875","chunk-6dec9764":"a363b965","chunk-7980c3b8":"0486f21b","chunk-7ab444ac":"621b64cd","chunk-b46a04a6":"f164291e","chunk-cc47f130":"2cd8674f","chunk-e3c30974":"340994a9","chunk-e983a736":"4196c4d9","chunk-ee63e24c":"7b3ebab0","chunk-010b1702":"7f80be90","chunk-201c62bc":"343ed27e","chunk-2d2223ef":"80e88911","chunk-4c0dd6c9":"98a65337","chunk-510346b1":"1381cafb","chunk-743c2ddb":"776715f1","chunk-745a3122":"b38b383d","chunk-7467d5b8":"487b1354","chunk-7482e5bc":"61cb5df8","chunk-74af77ea":"85df14ba","chunk-74b7681c":"918ce06a","chunk-74bb0962":"b32a316c","chunk-76f042f8":"6bc3b93c","chunk-774c8cf7":"aa91818a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0bf8c9de":1,"chunk-13510428":1,"chunk-142563fa":1,"chunk-36e63296":1,"chunk-2e8a43f2":1,"chunk-c4bcedc6":1,"chunk-34743a90":1,"chunk-3588aad4":1,"chunk-1a3c5ce6":1,"chunk-2d069e6b":1,"chunk-3a6364ea":1,"chunk-3c150860":1,"chunk-3e299a38":1,"chunk-5f7e28b4":1,"chunk-6e4f4f8e":1,"chunk-74f756a4":1,"chunk-b9ec4490":1,"chunk-69de510c":1,"chunk-a40ae960":1,"chunk-1156ef6a":1,"chunk-b47bfb9a":1,"chunk-ce8b6022":1,"chunk-47820dd6":1,"chunk-54239a8e":1,"chunk-5a8d37be":1,"chunk-5c790d61":1,"chunk-6dec9764":1,"chunk-7980c3b8":1,"chunk-7ab444ac":1,"chunk-b46a04a6":1,"chunk-cc47f130":1,"chunk-e3c30974":1,"chunk-e983a736":1,"chunk-ee63e24c":1,"chunk-010b1702":1,"chunk-201c62bc":1,"chunk-4c0dd6c9":1,"chunk-510346b1":1,"chunk-743c2ddb":1,"chunk-745a3122":1,"chunk-7467d5b8":1,"chunk-7482e5bc":1,"chunk-74af77ea":1,"chunk-74b7681c":1,"chunk-74bb0962":1,"chunk-76f042f8":1,"chunk-774c8cf7":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0bf8c9de":"35dd9266","chunk-13510428":"88b910f9","chunk-142563fa":"311f4651","chunk-36e63296":"d92f759b","chunk-2e8a43f2":"faa2dfcf","chunk-c4bcedc6":"e33c5f10","chunk-34743a90":"ce327a33","chunk-3588aad4":"447f7824","chunk-1a3c5ce6":"5e1d36ef","chunk-2d069e6b":"78d7b6db","chunk-3a6364ea":"152eb34d","chunk-3c150860":"9f69edb5","chunk-3e299a38":"9bb8e44f","chunk-5f7e28b4":"864736c7","chunk-6e4f4f8e":"a328ef23","chunk-74f756a4":"f0f1bebf","chunk-b9ec4490":"8dd1afeb","chunk-69de510c":"93c005aa","chunk-a40ae960":"d3aca9de","chunk-1156ef6a":"1398377f","chunk-b47bfb9a":"65011552","chunk-ce8b6022":"0f1abd28","chunk-47820dd6":"1aba7a05","chunk-54239a8e":"fef35e0d","chunk-5a8d37be":"fef35e0d","chunk-5c790d61":"dc45abfc","chunk-6dec9764":"31e241cf","chunk-7980c3b8":"78d7b6db","chunk-7ab444ac":"5fa2761b","chunk-b46a04a6":"2c46e14b","chunk-cc47f130":"20bd3869","chunk-e3c30974":"f2caa73c","chunk-e983a736":"29e1fe73","chunk-ee63e24c":"3a4a1d1f","chunk-010b1702":"51f80d91","chunk-201c62bc":"a6a6a033","chunk-2d2223ef":"31d6cfe0","chunk-4c0dd6c9":"64023625","chunk-510346b1":"417c6c07","chunk-743c2ddb":"0dd2478f","chunk-745a3122":"d7dc1639","chunk-7467d5b8":"97906909","chunk-7482e5bc":"3fc962f4","chunk-74af77ea":"23b17eb2","chunk-74b7681c":"6ff76692","chunk-74bb0962":"06c127ee","chunk-76f042f8":"a3d504dc","chunk-774c8cf7":"93e9293c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://presenter.ahaslides.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
